export const THRESHOLD_DANGER_STATUS = 90
